import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarService } from '@ibe/services/ui';
import { Observable } from 'rxjs';
import * as fromStore from '../../../../store';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import { INDRABookingComService } from '@ibe.services/booking-com.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { EXTRAS_ANCILLARY_BOOKING_HOTEL, SESSION_VAR_KEY_CURRENCY } from '@ibe.config';
import { EVENT_PRODUCT_BRAND_HOTELS, EVENT_ACTION_ADD_CART, INDRAGoogleAnalyticsService, EVENT_ACTION_REM_CART } from '@ibe.services/google.analytics.indra.service';


export class BookingRoom {
	id: string;
	hotel_id: string;
	image: string;
	name: string;
	// bed_count: string;
	description: string;
	facilities: string;
	price: string;
	// numRooms: Array<any> = [];
	refundable: boolean;
	seeCommodities: boolean;
	maxOccupancy: number;
	roomOptions: [{
		maxOccupancy: number;
		price: number,
		refundable: boolean,
		selected: number,
		currency: string
	}];
	blockId?: string;
}

@Component({
	selector: 'app-partner-hotel-detail',
	templateUrl: './partner-hotel-detail.indra.component.html',
	styleUrls: ['./partner-hotel-detail.component.scss']
})
export class INDRAPartnerHotelDetailComponent implements OnInit, OnDestroy {

	isAlive = true;
	edit = false;
	truncate = true;

	hotel;
	photosGallery;
	blockAvailability;
	rooms: Array<BookingRoom> = [];
	selectedHotelParam;
	routeParam;

	bookedTripExtras$: Observable<Array<any>> = this.store.select(fromStore.getSelectedBookedTripExtras);
	selectedHotels: Array<any> = [];
	bookedTripExtras: any;

	partnerHotelStopover$: Observable<any> = this.store.select(fromStore.getStopover);
	partnerHotelStopover: any;

	typeExtra = 'hotel';

	isLoading: boolean = false;
	editClicked: boolean = false;

	isStopoverHotel: boolean = false;
	hasError: boolean = false;

	isTicketStopoverHotel: boolean = false;

	hotels$: Observable<any> = this.store.select(fromStore.getStopoversHotels);
	numOfNights: any;

	constructor(
		private bookingComService: INDRABookingComService,
		protected route: ActivatedRoute,
		private store: Store<fromStore.State>,
		private sidebarService: SidebarService,
		private currencyService: INDRACurrencyService,
		protected ancillaryService: INDRAAncillariesService,
		private bfmStorage: INDRABFMDataStorageService,
		private router: Router,
		private googleAnalytics: INDRAGoogleAnalyticsService
	) {
		this.selectedHotelParam = this.bookingComService.getSearchParam();
		this.route.params.subscribe(value => { this.routeParam = value; });

		this.bookedTripExtras$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(extras => {

				if (!this.editClicked) {
					this.bookedTripExtras = extras;
					// check if user already selected a hotel to distinguish if edit mode or not
					const storeHotel = extras ? extras.find(item => item.type === 'hotel') : undefined;
					this.selectedHotels = storeHotel ? storeHotel.data.slice() : [];
					const data = this.selectedHotels.find(x => x.routeParam.city === this.routeParam.city);

					if (data) {
						this.edit = true;
						this.hotel = data.hotel;
						this.rooms = data.rooms.map(room => Object.assign({}, room));
						this.photosGallery = data.hotel.hotelData.hotel_photos.map(cur => ({ src: cur.url_original, label: this.hotel.name }));
					} else {
						this.edit = false;
						this.hotel = this.bookingComService.getHotel();
					}
				}

				if (extras) {
					this.isStopoverHotel = extras.some(extra => extra['stopoverHotel']);
				}
			});

		this.partnerHotelStopover$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.partnerHotelStopover = value;
				}
			});

		this.hotels$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					value.map(hotel => {
						this.numOfNights = hotel.hotelInfo.numNight;
					});
				}
			});
	}

	ngOnInit() {
		if (!this.edit) {
			this.INDRA_loadHotelRooms();
		}

		this.isTicketStopoverHotel = this.router.url.indexOf('/review-your-trip') > -1;
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	INDRA_save() {
		let price = 0;
		let currency = '';
		const selectedRooms = [];
		let stopoverInfoId: string = '';

		for (const i in this.rooms) {
			for (const j in this.rooms[i].roomOptions) {
				if (this.rooms[i].roomOptions[j].selected > 0) {
					price += +this.rooms[i].roomOptions[j].price * this.rooms[i].roomOptions[j].selected;
					currency = this.rooms[i].roomOptions[j].currency;
					if (!selectedRooms.find(selected => selected.id === this.rooms[i].id)) {
						selectedRooms.push(this.rooms[i]);
						stopoverInfoId = stopoverInfoId + this.rooms[i].id.toString();
					}
				}
			}
		}

		let selectedRoomPrice = 0;
		selectedRooms.forEach((room, index ) => {
			selectedRoomPrice = 0;
			for (let i = 0; i < room.roomOptions.length; i++) {
				if (room.roomOptions[i].selected > 0) {
					selectedRoomPrice += +room.roomOptions[i].price * room.roomOptions[i].selected;
					selectedRooms[index]['roomPrice'] = selectedRoomPrice;
				}
			}
		});

		if (this.editClicked) {
			const addedHotel = this.selectedHotels.find(x => x.routeParam.city == this.routeParam.city);
			stopoverInfoId = addedHotel.stopoverInfoId;
		}


		let param;
		if (this.isTicketStopoverHotel) {
			// API for ticket-stopover hotel
			
			let paramsArray = [];
			for (let i = 0; i < selectedRooms.length; i++) {
				param = {
					provider: 'SO_HOTEL',
					idReservation: this.partnerHotelStopover.location.value,
					bookableItemId: selectedRooms[i]['blockId'],
					description: selectedRooms[i]['description'],
					extraInfo: {
						checkin: this.selectedHotelParam.checkin,
						checkout: this.selectedHotelParam.checkout,
						name: this.hotel && this.hotel.hotelInfo ? this.hotel.hotelInfo.hotel_name : '',
						starRating: this.hotel && this.hotel.hotelInfo ? this.hotel.hotelInfo.stars.length : 0,
						country: this.routeParam.country
					},
					stopOverInfo: {
						[stopoverInfoId]: {
							currency: currency,
							amount: price,
							status: 'OK'
						},
					}
				};
				paramsArray.push(param);
			}
			
			let apiSuccess = true;
			paramsArray.forEach((params, index) => {
				this.ancillaryService.INDRA_addExternalReservation(params, 'SO_HOTEL').subscribe(res => {
					if (res && res.status === '200' && res.reservations) {
						if (index === paramsArray.length - 1 && apiSuccess) {
							this.INDRA_storeSelectedHotel(price, currency, selectedRooms, stopoverInfoId);
							this.sidebarService.closeSidebar();
						}
					}
				}, error => {
					if (error) {
						apiSuccess = false;
						this.hasError = false;
					}
				});
			});
			
		} else {
			// API for extras page hotel
			let paramsArray = [];
			for (let i = 0; i < selectedRooms.length; i++) {
				param = {
					provider: 'BOOKING',
					idReservation: selectedRooms[i]['hotel_id'].toString(),
					description: selectedRooms[i]['description'],
					currency: currency,
					amount: selectedRooms[i]['roomPrice'],
					status: 'OK',
					bookableItemId: selectedRooms[i]['blockId'],
					extraInfo: {
						checkin: this.selectedHotelParam.checkin,
						checkout: this.selectedHotelParam.checkout,
						city: this.partnerHotelStopover.location.value,
						name: this.hotel && this.hotel.hotelInfo ? this.hotel.hotelInfo.hotel_name : '',
						starRating: this.hotel && this.hotel.hotelInfo ? this.hotel.hotelInfo.stars.length : 0,
						country: this.routeParam.country
					}
				};
				paramsArray.push(param);
			}

			let apiSuccess = true;
			paramsArray.forEach((params, index) => {
				this.ancillaryService.INDRA_addExternalReservation(params, 'HOTEL').subscribe(res => {
					if (res && res.status === '200' && res.reservations) {
						this.INDRA_registerGA_hotels(res.reservations.BOOKING[0]);
						if (index === paramsArray.length - 1 && apiSuccess) {
							this.INDRA_storeSelectedHotel(price, currency, selectedRooms, stopoverInfoId);
							this.sidebarService.closeSidebar();
						}
					}
				}, error => {
					if (error) {
						apiSuccess = false;
						this.hasError = false;
					}
				});
			});

			this.isStopoverHotel = false;
		}
	}

	INDRA_registerGA_hotels(extra) {
		const activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip();
		activeBooking.hotel = extra;
		const eventDataLayerObject = this.googleAnalytics.IBE_createGA_ExtrasProducts(activeBooking);
		eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_ADD_CART);

		this.googleAnalytics.INDRA_GA_addToCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
	}

	INDRA_storeSelectedHotel(price, currency, selectedRooms, stopoverInfoId) {
		if (this.editClicked) {
			this.selectedHotels = this.selectedHotels.filter(x => x.routeParam.city !== this.routeParam.city);
		}

		this.selectedHotels.push({
			value: price.toFixed(2),
			currency: currency,
			routeParam: this.routeParam,
			checkin: this.bookingComService.searchParam.checkin,
			checkout: this.bookingComService.searchParam.checkout,
			hotel: this.hotel,
			rooms: selectedRooms,
			stopoverInfoId: stopoverInfoId
		});

		if (this.editClicked) {
			this.store.dispatch(new BookedTripActions.RemoveBookedTripExtraAction(this.typeExtra));
		}

		this.store.dispatch(new BookedTripActions.PutBookedTripExtrasAction({
			type: this.typeExtra,
			data: this.selectedHotels,
			value: this.selectedHotels[0].value,
			stopoverCity: this.partnerHotelStopover.location.value,
			stopoverHotel: this.isStopoverHotel
		}));

		this.editClicked = false;

	}


	INDRA_hotelDescription(text) {
		return this.truncate && text ? `${text.substr(0, 200)}...` : text;
	}

	INDRA_truncate() {
		return this.truncate = !this.truncate;
	}


	INDRA_printAddres() {
		return `${this.hotel.hotelInfo.address ? `${this.hotel.hotelInfo.address}` : ''}`;
		// ${this.routeParam.city}
	}

	INDRA_printStar(type, _ancillary) {
		const max_stars = 5;
		if (type === 'full') {
			return new Array(Math.floor(_ancillary.hotelInfo.stars));
		} else if (type === 'empty') {
			return new Array(max_stars - Math.floor(_ancillary.hotelInfo.stars));
		}
	}

	INDRA_hasStars(_ancillary): boolean {
		return _ancillary.hotelInfo.stars && _ancillary.hotelInfo.stars !== '';
	}


	INDRA_showMap() {
		this.sidebarService.openSidebar(['partner-hotel-location']);
	}

	INDRA_seeCommodities(room) {
		room.seeCommodities = !room.seeCommodities;
	}

	INDRA_getRoomSelections() {
		return this.rooms.filter(room => {
			if (room.roomOptions) {
				const selected = room.roomOptions.filter((option) => {
					return option.selected > 0;
				});
				return selected.length > 0;
			}
		});
	}

	INDRA_hasRoomSelections() {
		return this.INDRA_getRoomSelections().length > 0;
	}

	INDRA_RemoveHotel() {
		if (this.isStopoverHotel || this.isTicketStopoverHotel) {
			const param = 'SO_HOTEL/' + this.partnerHotelStopover.location.value;
			this.ancillaryService.INDRA_removeExternalReservation(param).subscribe(res => {
				if (res && res.status === '200') {
					/* const booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
					booked_trip.so_hotel = null;
					this.bfmStorage.INDRA_setActiveBookedTrip(booked_trip);
					this.INDRA_handleClose(); */

					this.hasError = false;
					this.INDRA_removeAction();
				} else {

				}
			}, error => {
				if (error) {
					this.hasError = true;
				}
			});
		} else {
			const params = 'city/' + this.partnerHotelStopover.location.value;
			this.ancillaryService.INDRA_removeExternalReservationByExtraInfo(EXTRAS_ANCILLARY_BOOKING_HOTEL, params).subscribe(res => {
				if (res && res.status === '200') {
					this.hasError = false;
					this.INDRA_removeAction();
				}
			}, error => {
				if (error) {
					this.hasError = true;
				}
			});
		}

	}

	INDRA_removeAction() {
		if (this.selectedHotels.length > 1) {
			const newHotels = this.selectedHotels.filter(x => x.routeParam.city !== this.routeParam.city);
			this.store.dispatch(new BookedTripActions.PutBookedTripExtrasAction({ type: this.typeExtra, data: newHotels, stopoverHotel: this.isStopoverHotel }));
		} else {
			this.store.dispatch(new BookedTripActions.RemoveBookedTripExtraAction(this.typeExtra));
		}
		this.INDRA_removeGA_Extra(EVENT_PRODUCT_BRAND_HOTELS, this.typeExtra);
		this.sidebarService.close();
	}

	INDRA_removeGA_Extra(type, extra) {
		const eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(type, extra);
		eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_REM_CART);

		this.googleAnalytics.INDRA_GA_removeFromCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
	}

	INDRA_getCurrencyUnit(currencyName) {
		return this.currencyService.INDRA_getCurrencySymbol(currencyName).unit;
	}

	INDRA_getRoomOccupancy(maxOccupancy: number) {
		if (maxOccupancy === 1) {
			return 'Single';
		} else if (maxOccupancy === 2) {
			return 'Couple';
		} else if (maxOccupancy > 2) {
			return 'Family';
		}
	}

	INDRA_changeHotel() {
		this.editClicked = true;
		this.edit = false;
		this.INDRA_loadHotelRooms();
	}

	INDRA_loadHotelRooms() {
		if (!this.selectedHotelParam) {
			this.selectedHotelParam = this.bookingComService.getSearchParam();
		}

		// load default search parameters
		if (this.selectedHotelParam.checkin == '' || this.selectedHotelParam.checkout == '' || this.selectedHotelParam.room1.length == 0)  {
			const details = this.bookingComService.generateSearchParam(this.partnerHotelStopover);
			this.selectedHotelParam.checkin = details.checkIn;
			this.selectedHotelParam.checkout = details.checkOut;
			this.selectedHotelParam.room1 = details.room1;
			this.selectedHotelParam.num_rooms = details.num_rooms;
		}
		const selectedHotelDetails = this.bookingComService.INDRA_blockAvailability({
			guest_cc: this.routeParam.guest_cc,
			checkin: this.selectedHotelParam.checkin,
			checkout: this.selectedHotelParam.checkout,
			hotel_ids: [this.routeParam.hotel_id],
			room1: this.selectedHotelParam.room1,
			currency: this.routeParam.currency,
			language: this.routeParam.language
		});

		if (this.editClicked) {
			this.rooms = [];
		}

		selectedHotelDetails
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(response => {
				if (response && response.status === '200') {
					this.blockAvailability = response.bookingAvailavilityHotelRooms.result[0].block;

					if (this.hotel.hotelData) {
						this.photosGallery = this.hotel.hotelData.hotel_photos.map(cur => ({ src: cur.url_original }));
					}

					for (const room of this.blockAvailability) {

						const roomPrice = room.incremental_price.find(price => price.price == (parseInt(this.numOfNights) * room.min_price.price).toFixed(1));

						if (roomPrice) {
							room.roomOptions = [{
								maxOccupancy: room.max_occupancy,
								price: roomPrice.other_currency ? roomPrice.other_currency.price : roomPrice.price,
								currency: roomPrice.other_currency ? roomPrice.other_currency.currency : roomPrice.currency,
								refundable: room.refundable,
								nights: this.numOfNights,
								selected: 0
						}];
					}

						this.rooms.push({
							id: room.room_id,
							hotel_id: this.hotel.hotelInfo.hotel_id,
							image: room.photos.length ? room.photos[0].url_max300 : null,
							name: room.name,
							description: room.room_description,
							facilities: room.facilities,
							price: room.min_price.price,
							refundable: room.refundable,
							// numRooms: [1],
							seeCommodities: false,
							maxOccupancy: room.max_occupancy,
							roomOptions: room.roomOptions,
							blockId: room.block_id
						});
					}
					this.isLoading = false;
				}
			});
	}
}
